import * as React from 'react';
import { connect } from 'react-redux';
import { getAccountBalance } from '../../api';
import { IAccountRes } from '@/services';
import './index.scss';

const { useEffect, useState } = React;

interface IProps {
    userData: IAccountRes;
}

function UserBar(props: IProps) {
    const [balance, setBalance] = useState<number>(0);
    const { serviceProviderName } = props.userData;
    useEffect(() => {
        getAccountBalance().then(res => {
            setBalance(Number(res.data));
        });
    }, []);

    return (
        <div className="settlement-top">
            <div className="settlement-l">
                <div className="avatar">
                    <img src="http://s3plus.meituan.net/v1/mss_c4375b35f5cb4e678b5b55a48c40cf9d/waimai-fem-service-market/waimai.png" />
                </div>
                <div>{serviceProviderName}</div>
            </div>
            <div className="settlement-r">
                <div className="settlement-title">账户余额</div>
                <div>￥{balance / 100}</div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: any) => ({
    userData: state.provider.user,
});

export default connect(mapStateToProps)(UserBar);
